import styled from 'styled-components'

export const ShimmerEquipment = styled.div`
  width: 315px;
  height: 100px;
  border-radius: 15px;

  background-image: linear-gradient(
    -90deg,
    #3737376b 0%,
    #393939d6 50%,
    #40404061 100%
  );

  background-size: 400% 400%;
  animation: shimmer 1.2s ease-in-out infinite;
  @keyframes shimmer {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }
  &.white {
    background-image: linear-gradient(
      -90deg,
      #3737376b 0%,
      #393939d6 50%,
      #40404061 100%
    );
  }
`
